/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Password change request
 */
export interface PasswordChangeRequest {
  oldPassword: string;
  newPassword: string;
}
